// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromLarge":"(min-width: 960px)","fiveRecipesContainer":"Gd36ab6 G5034bf G14e656 Ge28f91 G727c12","fiveRecipesText":"Gbfc329","leftArrow":"G258b71"};